<template>
  <div class="invoice">
    <div class="invoice-head">
      <span>{{ title }}</span>
    </div>
    <div class="invoice-body">
      <div class="invoice-body-form">
        <slot></slot>
      </div>
      <div class="invoice-body-info" v-if="showAddress">
        <div class="invoice-body-info-title">
          <span>{{ $t('发票寄送信息') }}</span>
          <span @click="openDialog">{{ $t('新增收货地址') }}</span>
        </div>
        <div class="invoice-body-info-address">
          <es-radio-group v-model="choosedAdd" @change="addressChanged" style="width: 100%">
            <div
              :class="['invoice-body-info-address-card', { defaultAdd: item.defaultFlag }]"
              v-for="(item, index) in addresses"
              :key="index"
            >
              <es-radio :label="item.addressId">
                <div class="addInfo">
                  <div class="addInfo-contact">
                    <div>{{ item.contact }}</div>
                    <div>{{ item.contactNumber }}</div>
                  </div>
                  <p>{{ item.addressAll }}</p>
                </div>
              </es-radio>
            </div>
          </es-radio-group>
        </div>
        <div class="invoice-body-info-price">
          <span>{{ $t('顺丰快递价格') }}</span>
          <span style="display: inline-block; width: 30px">{{ money >= 1000 ? 0 : price }}{{ $t('元') }}</span>
          <es-radio v-model="express" @change="chooseType" :label="1">{{ $t('支付快递费') }}</es-radio>
          <es-radio v-model="express" @change="chooseType" :label="2">{{ $t('货到付款') }}</es-radio>
        </div>
        <div style="margin-top: 10px">{{ $t('注意：目前暂不支持开具快递费发票，您可选择“货到付款”后向顺丰快递索要发票。') }}</div>
      </div>
    </div>
    <es-dialog :title="$t(`新增收货地址`)" class="dialog" :visible.sync="dialogVisible">
      <es-form :model="form" class="demo-form-inline" :label-width="labelWith" label-position="left" :rules="rules" ref="ruleForm">
        <es-form-item :label="$t(`姓名`)" style="display: inline-block; margin-right: 20px; width: 100%" prop="user">
          <es-input v-model="form.user" :placeholder="$t(`请输入收货人`)"></es-input>
        </es-form-item>
        <es-form-item :label="$t(`电话`)" style="display: inline-block; width: 100%" prop="phone">
          <es-input v-model="form.phone" :placeholder="$t(`请输入联系电话`)" style="width: 100%" maxlength="24"></es-input>
        </es-form-item>
        <es-form-item :label="$t(`地址`)" prop="address" style="width: 100%">
          <es-cascader
            :options="cascaderData"
            :props="props"
            v-model="form.address"
            @active-item-change="handleItemChange"
            style="width: 100%"
          ></es-cascader>
        </es-form-item>
        <es-form-item :label="$t(`详细地址`)" prop="DetailedAddress">
          <es-input v-model="form.DetailedAddress" :placeholder="$t(`请输入详细地址`)" type="textarea" :rows="3"></es-input>
          <br />
        </es-form-item>
      </es-form>
      <span slot="footer">
        <es-button type="primary" @click="onSubmit">{{ $t('保存') }}</es-button>
        <div variant="outline" @click="dialogVisible = false">{{ $t('取消') }}</div>
      </span>
    </es-dialog>
  </div>
</template>
<script>
import { $t, getLocale } from '@/locales'

export default {
  name: 'invoice',
  props: {
    title: {
      type: String,
      required: true,
    },
    money: {
      default: 0,
    },
    showAddress: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      choosedAdd: '',
      express: 1,
      address: {},
      addresses: [],
      price: 0,
      dialogVisible: false,
      form: {
        user: '',
        phone: '',
        address: [],
        DetailedAddress: '',
        defaultFlag: '',
      },
      props: {
        value: 'addressCode',
        label: 'address',
        children: 'cities',
      },
      cascaderData: [],
      rules: {
        user: [
          { max: 50, message: $t('长度不可以超过50个字符'), trigger: 'blur' },
          { required: true, message: $t('请输入收货人'), trigger: 'blur' },
        ],

        phone: [
          { required: true, message: $t('请输入联系电话'), trigger: 'blur' },
          { max: 20, message: $t('长度不可以超过20个字符'), trigger: 'blur' },
        ],

        address: [{ required: true, message: $t('请选择地址'), trigger: 'blur' }],
        DetailedAddress: [
          { required: true, message: $t('请输入详细地址'), trigger: 'blur' },
          { max: 100, message: $t('长度不可以超过100个字符'), trigger: 'blur' },
        ],
      },
    }
  },
  computed: {
    labelWith() {
      if (getLocale() === 'en-US') {
        return '140px'
      }

      return '80px'
    },
  },
  mounted() {
    this.init()
    this.express = 1
  },
  methods: {
    init() {
      this.getAddress()
    },
    emit() {
      this.$emit('getInfo', {
        fee: this.price,
        address: this.address,
        expressType: this.express,
      })
    },
    chooseType(val) {
      if (val === 2) {
        this.price = 0
      } else {
        this.addressChanged(this.choosedAdd)
      }
      this.emit()
    },
    getAddress() {
      this.$ajax(this.$url.getExpressAddress(), {
        offset: 0,
        size: 1000,
      }).then(res => {
        this.addresses = res.data.addresses
        if (this.addresses.length > 0) {
          this.choosedAdd = this.addresses[0].addressId
          this.addressChanged(this.choosedAdd)
        }
      })
    },
    addressChanged(data) {
      const province = this.addresses.filter(item => item.addressId === data)[0].province.address
      this.address = this.addresses.filter(item => item.addressId === data)[0]
      this.price = this.getPrice(province)
      if (this.express === 1) {
        this.price = this.getPrice(province)
      } else {
        this.price = 0
      }
      this.emit()
    },
    getPrice(province) {
      let price = 0
      if (province === $t('江苏省') || province === $t('浙江省') || province === $t('上海市')) {
        price = 12
      } else if (
        province === $t('西藏自治区') ||
        province === $t('新疆维吾尔自治区') ||
        province === $t('宁夏回族自治区') ||
        province === $t('西藏自治区') ||
        province === $t('澳门特别行政区') ||
        province === $t('香港特别行政区')
      ) {
        price = 26
      } else {
        price = 22
      }

      return price
    },
    openDialog() {
      this.getNodes()
      this.dialogVisible = true
    },
    getNodes(val) {
      // 选择省市区
      let idArea
      let sizeArea
      if (!val) {
        idArea = null
        sizeArea = 0
      } else if (val.length === 1) {
        // eslint-disable-next-line prefer-destructuring
        idArea = val[0]
        sizeArea = val.length
      } else if (val.length === 2) {
        // eslint-disable-next-line prefer-destructuring
        idArea = val[1]
        sizeArea = val.length
      }
      this.$ajax(this.$url.getAddress(), {
        addressCode: idArea,
      }).then(response => {
        const Items = response.data.addressTags
        if (sizeArea === 0) {
          // eslint-disable-next-line no-unused-vars
          this.cascaderData = Items.map((value, i) => ({
            addressCode: value.addressCode,
            address: value.address,
            cities: [],
          }))
        } else if (sizeArea === 1) {
          this.cascaderData.forEach(pro => {
            if (pro.addressCode === val[0]) {
              if (!pro.cities.length) {
                // eslint-disable-next-line no-shadow
                pro.cities = Items.map(city => ({
                  addressCode: city.addressCode,
                  address: city.address,
                  cities: [],
                }))
              }
            }
          })
        } else if (sizeArea === 2) {
          this.cascaderData.forEach(pro => {
            if (pro.addressCode === val[0]) {
              pro.cities.forEach(city => {
                if (city.addressCode === val[1]) {
                  if (!city.cities.length) {
                    city.cities = Items.map(value => ({
                      addressCode: value.addressCode,
                      address: value.address,
                    }))
                  }
                }
              })
            }
          })
        }
      })
    },
    handleItemChange(val) {
      this.getNodes(val)
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const data = {
            contact: this.form.user,
            contactNumber: this.form.phone,
            province: this.form.address[0],
            city: this.form.address[1],
            area: this.form.address[2],
            addressDetail: this.form.DetailedAddress,
            defaultFlag: this.form.defaultFlag,
          }
          this.$ajax(this.$url.addAddress(), {
            ...data,
          }).then(res => {
            this.$message({
              message: res.message,
              type: 'success',
            })
            this.getAddress()
            this.emit()

            this.dialogVisible = false
          })
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
@3: #1a1a1a;
.invoice {
  width: 100%;
  padding: 20px;
  background-color: #f8f8f8;
  &-head {
    height: 34px;
    border-bottom: 1px solid #eeeeee;
    font-size: 16px;
    color: @3;

    font-weight: 500;
    margin-bottom: 20px;
  }
  &-body {
    &-form {
      position: relative;
      height: 200px;
    }
    &-info {
      padding-top: 20px;
      &-title {
        height: 34px;
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #eeeeee;
        span {
          font-size: 15px;
          color: @3;
          &:nth-child(2) {
            font-size: 12px;
            color: #1875f0;
            cursor: pointer;
          }
        }
      }
      &-address {
        padding: 5px 0 10px 0;
        &-card {
          width: 100%;
          height: 88px;
          margin: 10px 0;
          background: white;

          .es-radio__label {
            flex: 1;
            position: relative;
            display: flex;
            align-items: center;
          }
        }
      }
      &-price {
        display: flex;
        align-items: center;
        span {
          &:nth-child(2) {
            margin-right: 5px;
          }
          &:nth-child(3) {
            color: #0975e0ff;
            margin-right: 40px;
          }
        }
      }
    }
  }
}
.invoice-body-info-address-card {
  display: flex;
  align-items: center;
  padding-left: 16px;
  .es-radio {
    display: flex;
    align-items: center;
  }
}

.addInfo {
  line-height: 20px;
  font-size: 14px;
  color: @3;
  &-contact {
    display: flex;
    width: 168px;
    justify-content: space-between;
  }
  p {
    margin-top: 7px;
  }
}
.defaultAdd {
  border: 1px solid #e74333;
  position: relative;
  &::after {
    content: '默认收货地址';
    position: absolute;
    right: 0;
    top: 0;
    width: 90px;
    height: 30px;
    color: white;
    font-size: 12px;
    background: #e74333;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.dialog {

  .demo-form-inline {
    width: 100%;
  }
  &-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    &-btn {
      width: 80px;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      margin: 0 10px 20px 10px;
      &:nth-child(1) {
        background: #0975e0ff;
        color: white;
      }
      &:nth-child(2) {
        background: #e4e4e4;
        color: #727272;
      }
    }
  }
}
</style>
